







import { Component, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import loading from '@/components/loading.vue';

@Component({
    components: {
        loading,
    },
})
export default class App extends Vue {
    @Getter('isLoading') public isLoading: boolean;
}
